module.exports = __webpack_public_path__ + "static/Gibson-SemiBold-webfont-eba4f5512beddcc3c3ad690d93d0a452.ttf";